import { parseResponse } from 'utils/api'

export const MAX_SOURCE_IMAGE_BYTES = 2 * 1024 * 1024
export const SOURCE_IMAGE_SIZE_MESSAGE = 'Choose an image that is 2 MB or smaller.'
export const MAX_IMAGE_BYTES = 1024 * 1024
export const IMAGE_SIZE_MESSAGE = 'The cropped image is too large to upload. Try a smaller crop or choose another image.'
const GENERIC_MESSAGE = 'Couldn’t upload the image. Please try again.'

export const getUploadErrorMessage = (error) => {
  const status = Number(error?.status)
  if (status === 413 || error?.code === 'IMAGE_TOO_LARGE') return IMAGE_SIZE_MESSAGE
  if (status === 401) return 'Your session has expired. Sign in and try again.'
  if (status === 403) return 'You don’t have permission to upload this image.'
  if (status === 415) return 'Choose a valid JPG or PNG image.'
  if (status === 429) return 'Too many upload attempts. Wait a moment and try again.'
  if (status >= 500) return 'Image upload is temporarily unavailable. Please try again later.'
  if (error instanceof TypeError) return 'Couldn’t connect. Check your connection and try again.'
  const reason = typeof error === 'string' ? error : error?.message || error?.error
  // Only translate known validation messages; never display arbitrary server text.
  if (['File is too large', 'Image size must be 1 MB or less.'].includes(reason)) return IMAGE_SIZE_MESSAGE
  if (['Unsupported image encoding', 'Choose a valid JPG or PNG image.', 'Choose a JPG or PNG image to upload.'].includes(reason)) {
    return 'Choose a valid JPG or PNG image.'
  }
  return GENERIC_MESSAGE
}

export const parseImageUploadResponse = async (response) => {
  try {
    const result = await parseResponse(response)
    if (typeof result?.result !== 'string' || !result.result) throw new Error('Missing image URL')
    return result
  } catch (error) {
    const failure = new Error(error?.message || error?.error || 'Image upload failed')
    failure.status = response.status
    throw failure
  }
}
